import axios from "axios";
import { API_BASE_URL } from "../environment";

export const getAllSchools = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/schools?start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
